import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { RenderHTML } from "@learningblocks/shared-components";

/**
 * OptionFeedback:
 *  - Feedback message for a particular Option
 */
export function OptionFeedback(props) {
  if (props.visible) {
    return (
      <div className={`${style.feedback} ${props.className}`}>
        <RenderHTML content={props.text} />
      </div>
    );
  } else return null;
}

OptionFeedback.propTypes = {
  /**
   * Boolean specifying if feedback is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * text to be displayed as feedback
   */
  text: PropTypes.string.isRequired,
  /**
   * className to be set for feedback element
   */
  className: PropTypes.string,
};

OptionFeedback.defaultProps = {
  visible: false,
  text: "",
};
